import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Card from 'kepler/lib/components/Card';

const RecommendedToolsCard = props => {
  const { tool, handleClick } = props;

  return (
    <Card className="myapps-card myapps-card-recommended">
      <img src={get(tool, 'icon')} alt="" role="presentation" />
      <h4>{get(tool, 'name')}</h4>
      <div className="myapps-card-content">
        <p>{get(tool, 'description')}</p>
      </div>
      <div className="myapp--btn" type="inline">
        <a
          className="Button Button--secondary Button--sm"
          href={get(tool, 'link.url', '')}
          onClick={() => {
            handleClick(tool);
          }}
        >
          {get(tool, 'link.text', '')}
        </a>
      </div>
    </Card>
  );
};

RecommendedToolsCard.propTypes = {
  tool: PropTypes.object,
  handleClick: PropTypes.func
};

export default RecommendedToolsCard;
